import React from "react";

interface PopupHeaderProps {
  title: string;
  onClose: () => void;
}

const PopupHeader: React.FC<PopupHeaderProps> = ({ title, onClose }) => {
  return (
    <div className="flex justify-between items-center px-5 py-4 border-b border-ez-border bg-ez-elevated rounded-tl-xl rounded-tr-xl">
      <h2 className="text-base font-semibold text-ez-text-primary">{title}</h2>
      <button
        onClick={onClose}
        aria-label="Close"
        className="flex items-center justify-center w-7 h-7 rounded-md text-ez-text-secondary hover:text-ez-text-primary hover:bg-ez-border transition-colors"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  );
};

export default PopupHeader; 


